<template>
    <b-card no-body>
        <template #header>
            <strong>Workflows</strong>
        </template>

        <div class="p-1">
            <b-row>
                <b-col cols="12">
                    <div>
                        <div style="display: inline-flex;">
                            <NotificationTile is_notification @selectNotification="setSelectedItem" :selected_index="selected_index" :notification="{id: 1, name: 'Sop Assignment', length: 0, icon: 'fa-file-export'}" hide_notification_count/>
                            <!-- <NotificationTile @selectNotification="setSelectedItem" :selected_index="selected_index" :notification="{id: 0, name: 'Document Approval', length: 0, icon: 'fa-file-signature'}" hide_notification_count/> -->
                        </div>
                    </div>
                </b-col>
            </b-row>

            <div v-show="selected_index != -1">
                <div v-show="selected_index == 0">
                    Doc Approval Here
                </div>
                <div v-show="selected_index == 1">
                    <SopAssignment />
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import Table from './components/clientUsersTable.vue'
import LevelsOrgChart from './components/levelOrgChart.vue'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'

import NotificationTile from '@/components/widgets/misc/notificationIcon.vue'
import SopAssignment from './workflowSopAssignment.vue'
export default {
    data:() => ({
        selected_index: 1,
        
        // old
        has_mounted: false,
        selected_level_id: null,
    }),
    components:{
        //eslint-disable-next-line
        Table,
        //eslint-disable-next-line
        LevelsOrgChart,
        NotificationTile,
        SopAssignment,
    },
    computed:{
        ...clientAdminState,
    },
    methods:{
        ...clientAdminMethods,
        setSelectedItem(payload){
            console.log(payload)
            this.selected_index = payload.notification.id;
        },
        setID(id){
            this.selected_level_id = id;
            this.$refs.administrationTabs.previousTab();
        }
    },
    mounted(){
        if(this.user_levels == null){
            this.loadLevels()
            .then(()=>{
                this.has_mounted = true;
            })
        }
        else{
            this.has_mounted = true;
        }
    },
}
</script>

<style>

</style>